import axios from "axios"
import route from "@main/config/routes.js"
import {formMethod} from "@main/helpers"

const $modal = $(".js-modal-alert");

$(document).on("change", ".js-compare-product", (e) => {

    const el = $(e.target);

    const compareCountNode = $(".js-compare-count");

    let isChecked = el.prop("checked"),
        count = parseInt(compareCountNode.text()),
        id = el.attr("id");

    axios({
        url: route.compareProducts,
        data: {
            id: id,
            isChecked: isChecked
        },
        method: formMethod("post"),
        headers: {"Content-Type": "application/json"},
    }).then((res) => {
        if(res.data.success){

            if(isChecked){
                count++;
            }else{
                count--;
            }

            if(count <= 0){
                compareCountNode.closest(".compare-wrap").hide();
            }else{
                compareCountNode.closest(".compare-wrap").show();
            }

            compareCountNode.text(count);

        }else{
            $modal.find (".js-modal-title").html();
            $modal.find (".js-modal-text").html(res.data.message);
            $modal.addClass("fade-in opened")
                .removeClass("fade-out");
        }
    }).catch(() => {
        alert("Что-то пошло не так...\nПопробуйте обновить страницу");
    });
});

